module.exports = __webpack_public_path__ + "img/lite.936eda77.png";